import omit from 'lodash/omit'
import { IShipmentStop, CreateLoadSchemaType } from 'apps/fleet-planner/schema'
import { getFieldStops } from './getFieldsByStopType'

/**
 * The backend infers the stop order on load creation
 */
const sanitizeStopData = (stops: IShipmentStop[] = []): Omit<IShipmentStop, 'id'>[] => {
  const { pickup = [], dropoff = [] } = getFieldStops(stops)
  return [...pickup, ...dropoff].map((stop, i) =>
    omit(
      {
        ...stop,
        stopSequence: i + 1, // Add `stopSequence` based on index
      },
      'id'
    )
  )
}

/**
 * Sanitizes data to be used in a POST request to /shipments
 */
export const getCreateLoadRequest = (data: CreateLoadSchemaType): CreateLoadSchemaType => ({
  ...data,
  stops: sanitizeStopData(data.stops),
})
